import { Column } from '@askyourteam-nz/react-library/dist/elements/layout'; // eslint-disable-line import/no-internal-modules

export default Column;
